import {
  Injectable,
  inject,
  EnvironmentInjector,
  runInInjectionContext,
} from "@angular/core";
import { Database, ref, objectVal } from "@angular/fire/database";
import { Observable } from "rxjs";

// Site-wide announcement banner (see AnnouncementComponent).
//
// This service used to also subscribe to /events (the whole rolling day of
// activity, ~235 KB per session) for a live feed that was no longer routed and
// a unique-locations list nothing read. Those subscriptions are gone; the
// homepage map now reads the hourly public/activity-map.json Storage file instead.
@Injectable({
  providedIn: "root",
})
export class EventService {
  announcementAF: Observable<any>;
  announcement!: Announcement | null;

  private readonly mdb = inject(Database);
  private readonly injector = inject(EnvironmentInjector);

  constructor() {
    this.announcementAF = runInInjectionContext(this.injector, () =>
      objectVal<Announcement>(ref(this.mdb, "announcement"))
    );
    this.announcementAF.subscribe((announcement) => {
      if (
        announcement &&
        announcement.text &&
        announcement.url &&
        announcement.ctaText
      )
        this.announcement = this.truncateAnnouncementText(announcement);
      else this.announcement = null;
    });
  }

  private truncateAnnouncementText(announcement: Announcement): Announcement {
    const maxLength = 140;
    const totalLength = announcement.ctaText.length + announcement.text.length;

    if (totalLength > maxLength) {
      // Calculate how much we need to truncate
      const truncateLength = totalLength - maxLength + 3; // Add 3 for the ellipsis

      // Truncate the text and add an ellipsis
      announcement.text = `${announcement.text.substring(
        0,
        announcement.text.length - truncateLength
      )}...`;
    }

    return announcement;
  }
}

export interface Announcement {
  text: string;
  url: string;
  ctaText: string;
}
